import { Outlet } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { ClientEmployeeTabs } from "@components/Tabs";

import { Box } from "@design-system/Box/Box";

import { routes } from "@pages/routes";

export const ClientEmployee = () => {
  const { clientId, clientEmployeeId } = useTypedParams(
    routes.portal.clients.client.clientEmployees.clientEmployee,
  );

  return (
    <Box direction="column" gap={16} stretch>
      <Box stretch>
        <ClientEmployeeTabs
          clientId={clientId}
          clientEmployeeId={clientEmployeeId}
        />
      </Box>
      <Outlet />
    </Box>
  );
};
